export const BANNER_SHOW_TABS = ['general'] as const;

export type BannerShowTab = (typeof BANNER_SHOW_TABS)[number];

export const BANNER_DEFAULT_TAB: BannerShowTab = 'general';
